<table mat-table [dataSource]="dataSource" id="quantities-table" matSort>
  <ng-container matColumnDef="packagingId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ idFieldName }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.packagingId}} </td>
  </ng-container>

  <ng-container matColumnDef="countryName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataEvaluation.viewEvaluations.quantities.table.countryName' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.countryName}} </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataEvaluation.viewEvaluations.quantities.table.date' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.date}} </td>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataEvaluation.viewEvaluations.quantities.table.quantity' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element">{{element.quantity}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
